import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M20.132 11.075c-.446.05-.876.2-1.256.437l-15.232 9.52a3.5 3.5 0 0 0 .002 5.938l15.252 9.519a3 3 0 0 0 4.57-2.212q.534-4.792.532-10.183a3.5 3.5 0 0 0 1.646 2.876l15.252 9.519a3 3 0 0 0 4.57-2.212q.535-4.804.532-10.213-.004-5.439-.553-10.342a3 3 0 0 0-4.571-2.21l-15.232 9.52A3.5 3.5 0 0 0 24 23.923q-.01-5.36-.553-10.2a3 3 0 0 0-3.315-2.647M24 23.923v.17zM4.704 22.729l15.232-9.52a1 1 0 0 1 1.524.736q.535 4.79.54 10.12.003 5.3-.52 9.99a1 1 0 0 1-1.523.737L4.705 25.273a1.5 1.5 0 0 1 0-2.544m22 0a1.5 1.5 0 0 0 .001 2.544l15.252 9.52a1 1 0 0 0 1.523-.738q.523-4.69.52-9.99-.004-5.33-.54-10.12a1 1 0 0 0-1.524-.737z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "mask",
    {
      id: "Rewind-Outlined_svg__a",
      width: 45,
      height: 26,
      x: 1,
      y: 11,
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M20.132 11.075c-.446.05-.876.2-1.256.437l-15.232 9.52a3.5 3.5 0 0 0 .002 5.938l15.252 9.519a3 3 0 0 0 4.57-2.212q.534-4.792.532-10.183a3.5 3.5 0 0 0 1.646 2.876l15.252 9.519a3 3 0 0 0 4.57-2.212q.535-4.804.532-10.213-.004-5.439-.553-10.342a3 3 0 0 0-4.571-2.21l-15.232 9.52A3.5 3.5 0 0 0 24 23.923q-.01-5.36-.553-10.2a3 3 0 0 0-3.315-2.647M24 23.923v.17zM4.704 22.729l15.232-9.52a1 1 0 0 1 1.524.736q.535 4.79.54 10.12.003 5.3-.52 9.99a1 1 0 0 1-1.523.737L4.705 25.273a1.5 1.5 0 0 1 0-2.544m22 0a1.5 1.5 0 0 0 .001 2.544l15.252 9.52a1 1 0 0 0 1.523-.738q.523-4.69.52-9.99-.004-5.33-.54-10.12a1 1 0 0 0-1.524-.737z",
        clipRule: "evenodd"
      }
    )
  ),
  /* @__PURE__ */ React.createElement("g", { mask: "url(#Rewind-Outlined_svg__a)" }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M0 0h48v48H0z" }))
);
var SvgRewindOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var RewindOutlined_default = SvgRewindOutlined;

export { RewindOutlined_default as default };
